/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { networkGetNetworkMyip } from "../../funcs/networkGetNetworkMyip.js";
import { GetNetworkMyipRequest$zodSchema } from "../../models/getnetworkmyipop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: GetNetworkMyipRequest$zodSchema.optional(),
};

export const tool$networkGetNetworkMyip: ToolDefinition<typeof args> = {
  name: "network-get-network-myip",
  description: `查询我的 IP

想知道你自己的出口公网IP是多少吗？这个接口就是你的“网络身份证”。你可以使用默认数据源，也可以指定 \`source=commercial\` 参数来查询更详细的商业级IP归属信息。

## 功能概述
调用此接口，它会返回你（即发起请求的客户端）的公网IP地址，并附带与 \`/network/ipinfo\` 接口相同的地理位置和网络归属信息。非常适合用于在网页上向用户展示他们自己的IP和地理位置。

当使用 \`source=commercial\` 参数时，接口将调用高性能商业API，提供更精确的市、区、运营商、时区、海拔等信息。请注意，商业查询的响应时间可能会稍长。`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await networkGetNetworkMyip(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
